import { SimpleGrid, VStack } from '@chakra-ui/react'
import { Control } from 'react-hook-form'
import type {
  PropertyFormInput,
  PropertyFormOutput,
} from '../../../../../schemas/propertySchema'
import { FormCurrencyInput } from '../../../../ui/FormFields'
import { FormPercentageInput } from '../../../../ui/FormFields/FormPercentageInput'

interface CostsManagementStepProps {
  control: Control<PropertyFormInput<boolean>, any, PropertyFormOutput<boolean>>
}

export function CostsManagementStep({ control }: CostsManagementStepProps) {
  return (
    <VStack spacing={6} align="stretch">
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormCurrencyInput
          name="cleaning_fee"
          label="Taxa de Limpeza"
          control={control}
          isRequired
        />

        <FormPercentageInput<PropertyFormInput>
          name="management_cost_percentage"
          label="Percentual de Gestão (%)"
          control={control}
          isRequired
          min={0}
          max={100}
          step={0.1}
        />
      </SimpleGrid>
    </VStack>
  )
}
